import React, { useEffect, useState } from "react";
import * as Const from "./../_Const";
import { useFormCtx } from "./../FormContext";
import useScreenType from "./../hooks/useScreenType";

const Button = ({
  className,
  title,
  onClick,
  type = "next",
  place = "right",
  showIcon = true,
  canWrap = true,
  forceBeepDisabled = false,
  onToggleStateChange = null,
  toggleState = false,
  textTransformCss = "uppercase",
  customButtonStyle = "",
}) => {
  const screenType = useScreenType();
  const { isAnimationDisabled, beep } = useFormCtx();
  const [isPressed, setIsPressed] = useState(false);
  const [isOn, setIsOn] = useState(toggleState);
  const [fade, setFade] = useState(false);
  const [isReadOnly, setReadOnly] = useState(false);
  let icon = "";
  let colorClasses = "";
  const isTerminal = Const.isTerminal();
  const fadeClass = fade ? "fade" : "";
  let spanCss = "flex-auto";
  let toggleCsss = "";
  let toggleStyle = isOn ? "bg-accent" : "bg-toggle-off";
  let canUseFade = !isAnimationDisabled && !isTerminal;
  const terminalClasses = isTerminal ? "active:bg-accent-darka active:text-accent-secondarya" : "";

  const isClickOnceType = type === "clickonce" || type === "clickonce-red";

  function handleClick() {
    if (isClickOnceType) {
      setReadOnly(true);
    }
    if (type === "toggle") {
      setIsOn(!isOn);
      if (onToggleStateChange) {
        onToggleStateChange(!isOn);
      }
    }

    if (canUseFade) {
      setFade(true);
    } else {
      setIsPressed(true);

      setTimeout(
        () => {
          onClick && onClick();
          setIsPressed(false);
        },
        // beep();
        250,
      );
    }

    if (!forceBeepDisabled) {
      beep();
    }
  }

  function onAnimationEnd() {
    setFade(false);
    setIsPressed(false);
    if (onClick) {
      console.log("onanimationend");

      onClick();
    }
  }

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "terminal-document-icon":
          css = "w-10 h-10";
          break;
        case "toggle-line":
          css = "w-[18px] h-[6px]";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "terminal-document-icon":
          css = "w-[54px] h-[54px]";
          break;
        case "toggle-line":
          css = "w-[28px] h-[8px]";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "terminal-document-icon":
          css = "w-[54px] h-[54px]";
          break;
        case "toggle-line":
          css = "w-[28px] h-[8px]";
          break;
      }
    } else if (screenType === Const.SCREEN_PHONE) {
      switch (what) {
        case "terminal-document-icon":
          css = "w-[54px] h-[54px]";
          break;
        case "toggle-line":
          css = "w-[28px] h-[8px]";
          break;
      }
    }
    //console.log(what, screenType, css);

    return css;
  }

  if (type === "next") {
    colorClasses = `transition-colors ${isPressed ? "text-white bg-accent-dark" : "text-accent-dark bg-accent-secondary"} `; //"text-accent-dark bg-accent-secondary";
    icon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="flex-none w-8 fill-accent-dark hover:fill-white active:fill-white"
        width="11.617"
        height="18"
        viewBox="0 0 11.617 18"
      >
        <path
          id="Icon_awesome-angle-right"
          data-name="Icon awesome-angle-right"
          d="M12.961,16.7,5.314,24.35a1.344,1.344,0,0,1-1.906,0L2.137,23.079a1.344,1.344,0,0,1,0-1.906l5.421-5.421L2.137,10.331a1.344,1.344,0,0,1,0-1.906L3.4,7.143a1.344,1.344,0,0,1,1.906,0l7.648,7.648A1.346,1.346,0,0,1,12.961,16.7Z"
          transform="translate(-1.74 -6.746)"
        />
      </svg>
    );
  } else if (type === "back") {
    colorClasses = "border border-secondary hover:border-accent-secondary text-secondary hover:text-accent-dark hover:bg-accent-secondary";
    icon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9.035"
        height="14"
        viewBox="0 0 9.035 14"
        className="flex-none w-8 fill-secondary  group-hover:fill-accent-dark"
      >
        <path
          id="Icon_awesome-angle-right"
          data-name="Icon awesome-angle-right"
          d="M10.468,14.49,4.52,20.438a1.045,1.045,0,0,1-1.483,0l-.988-.988a1.045,1.045,0,0,1,0-1.483l4.216-4.216L2.049,9.535a1.045,1.045,0,0,1,0-1.483l.984-1a1.045,1.045,0,0,1,1.483,0L10.463,13A1.047,1.047,0,0,1,10.468,14.49Z"
          transform="translate(10.776 20.746) rotate(180)"
        />
      </svg>
    );
  } else if (type === "error") {
    colorClasses = `transition-colors text-white ${isPressed ? "bg-error-dark" : "bg-error"} `; //"text-white  bg-error";
  } else if (type === "navbar") {
    colorClasses = "text-accent-dark  bg-white";
  } else if (type === "error-dark") {
    colorClasses = `transition-colors text-white ${isPressed ? "bg-error" : "bg-error-dark"} `;
  } else if (type === "clickonce") {
    colorClasses = isReadOnly
      ? `transition-colors  ${isPressed ? "text-white bg-accent" : "text-disabled bg-disabled-dark"} `
      : "text-accent-dark bg-accent-secondary";
  } else if (type === "clickonce-red") {
    colorClasses = isReadOnly
      ? `transition-colors  ${isPressed ? "bg-error-dark text-white" : "text-disabled bg-disabled-dark"} `
      : `transition-colors text-white ${isPressed ? "bg-error-dark" : "bg-error bg-accent-secondary"} `;
  } else if (type === "primary") {
    colorClasses = `transition-colors text-white ${isPressed ? "bg-accent-dark" : "bg-accent"} `;
    icon = (
      <svg xmlns="http://www.w3.org/2000/svg" className="flex-none w-8 fill-white" width="11.617" height="18" viewBox="0 0 11.617 18">
        <path
          id="Icon_awesome-angle-right"
          data-name="Icon awesome-angle-right"
          d="M12.961,16.7,5.314,24.35a1.344,1.344,0,0,1-1.906,0L2.137,23.079a1.344,1.344,0,0,1,0-1.906l5.421-5.421L2.137,10.331a1.344,1.344,0,0,1,0-1.906L3.4,7.143a1.344,1.344,0,0,1,1.906,0l7.648,7.648A1.346,1.346,0,0,1,12.961,16.7Z"
          transform="translate(-1.74 -6.746)"
        />
      </svg>
    );
  } else if (type === "terminal-dark") {
    //console.log("xxx isPressed", isPressed);

    colorClasses = `transition-colors text-white ${isPressed ? "bg-accent-dark" : "bg-disabled-dark"} `; //"text-white bg-disabled-dark active:bg-accent-dark";
    spanCss = "";
    canUseFade = false;
    icon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        //height=
        viewBox="0 -960 960 960"
        // width={`${getCssFor("terminal-document-icon")}`}
        className={`${getCssFor("terminal-document-icon")} fill-white flex-none`}
      >
        <path d="M160-80q-33 0-56.5-23.5T80-160v-360q0-33 23.5-56.5T160-600h80v-200q0-33 23.5-56.5T320-880h480q33 0 56.5 23.5T880-800v360q0 33-23.5 56.5T800-360h-80v200q0 33-23.5 56.5T640-80H160Zm0-80h480v-280H160v280Zm560-280h80v-280H320v120h320q33 0 56.5 23.5T720-520v80Z" />
      </svg>
    );
  } else if (type === "toggle") {
    colorClasses = `transition-colors text-white ${isPressed ? "bg-accent-dark" : "bg-disabled-dark"} `; //"text-white bg-disabled-dark active:bg-accent-dark";
    textTransformCss = "lowercase";
    toggleCsss = "relative";
    spanCss = "";
    canUseFade = false;
  } else if (type === "terminal") {
    colorClasses = `transition-colors text-white ${isPressed ? "bg-accent-dark" : "bg-accent"} `; //"text-white bg-accent active:bg-accent-dark";
    spanCss = "";
    canUseFade = false;
    icon = (
      <svg xmlns="http://www.w3.org/2000/svg" className="flex-none w-8 fill-white" width="11.617" height="18" viewBox="0 0 11.617 18">
        <path
          id="Icon_awesome-angle-right"
          data-name="Icon awesome-angle-right"
          d="M12.961,16.7,5.314,24.35a1.344,1.344,0,0,1-1.906,0L2.137,23.079a1.344,1.344,0,0,1,0-1.906l5.421-5.421L2.137,10.331a1.344,1.344,0,0,1,0-1.906L3.4,7.143a1.344,1.344,0,0,1,1.906,0l7.648,7.648A1.346,1.346,0,0,1,12.961,16.7Z"
          transform="translate(-1.74 -6.746)"
        />
      </svg>
    );
  } else if (type === "terminal-error") {
    // colorClasses = "text-white bg-accent active:bg-accent-dark";
    colorClasses = `transition-colors text-white ${isPressed ? "bg-error-dark" : "bg-error"} `; //"text-white active:text-white bg-error active:bg-error-dark";
    spanCss = "";
    canUseFade = false;
    icon = (
      <svg xmlns="http://www.w3.org/2000/svg" className="flex-none w-8 fill-white" width="11.617" height="18" viewBox="0 0 11.617 18">
        <path
          id="Icon_awesome-angle-right"
          data-name="Icon awesome-angle-right"
          d="M12.961,16.7,5.314,24.35a1.344,1.344,0,0,1-1.906,0L2.137,23.079a1.344,1.344,0,0,1,0-1.906l5.421-5.421L2.137,10.331a1.344,1.344,0,0,1,0-1.906L3.4,7.143a1.344,1.344,0,0,1,1.906,0l7.648,7.648A1.346,1.346,0,0,1,12.961,16.7Z"
          transform="translate(-1.74 -6.746)"
        />
      </svg>
    );
  }

  function replaceWithBr(text, canWrap) {
    if (canWrap && text) {
      return text.replace(/\n/g, "<br />");
    }
    return text;
  }

  if (screenType === Const.SCREEN_UNKNOWN) {
    return;
  }

  return (
    <button
      onClick={handleClick}
      onAnimationEnd={onAnimationEnd}
      disabled={isReadOnly}
      //onTouchStart={() => setIsPressed(true)}
      //onTouchEnd={() => setIsPressed(false)}
      className={`select-none flex  place-content-center  items-center  group min-h-12 px-4 py-2 font-bold text-md  rounded-2xl shadow-md 
      ${colorClasses} ${className} ${fadeClass} ${terminalClasses} ${textTransformCss} ${toggleCsss}`}
      style={customButtonStyle ? customButtonStyle : {}}
    >
      {showIcon && place === "left" && icon}
      <span className={`mx-4 ${spanCss}`} dangerouslySetInnerHTML={{ __html: replaceWithBr(title, canWrap) }} />
      {type === "toggle" && <div className={`absolute bottom-1 ${getCssFor("toggle-line")} ${toggleStyle}`}>&nbsp;</div>}
      {showIcon && place === "right" && icon}
    </button>
  );
};

export default Button;
